exports = module.exports = require("../../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2Vc5PsqXoJ_CNFSaLIrUsf ._1ZDa3yjEwrXvObw8DIlqNL{box-sizing:border-box}", ""]);
// Exports
exports.locals = {
	"monaco-editor": "_2Vc5PsqXoJ_CNFSaLIrUsf",
	"bracket-match": "_1ZDa3yjEwrXvObw8DIlqNL"
};